import React, { useEffect } from 'react'
import LimitTypeTable from './blocks/limitTypeTable/LimitTypeTable'
import CardInfoHeader from './blocks/limitAndBlockCardPage'
import { useFetchCardLimitsQuery } from 'store/reducers/limitsforBusinnesCard/cardLimits.api'
import { useAppSelector } from '@shared/hooks/useAppSelector'
import BeatLoader from '../../../../../shared/BeatLoader/BeatLoader'

function LimitsModalMain() {
  const pan = useAppSelector((state) => state.employeePan.pan)
  const { data, isError, isFetching, isSuccess } = useFetchCardLimitsQuery(pan)

  return isFetching  ? (
    <BeatLoader  size={15} margin={6}  />
  ) 
  : isSuccess ? (
    <>
      <CardInfoHeader data={data} />
      <LimitTypeTable data={data} />
    </>
  ) : (
    <></>
  )
}

export default LimitsModalMain
